import { Select } from 'antd';
import { omit } from 'lodash';
import useHttpClient from 'hooks/useHttpClient';
import { useQuery } from '@tanstack/react-query';
import { masterDataKeys } from 'features/lost-found-management/keys';
import { appApiMasterIndices } from 'configs/variables';

const { Option } = Select;

export function SpSelectItemBrand(props) {
  const { data, isLoading } = useSpSelectItemBrand({ params: props?.params });

  return (
    <Select
      {...props}
      showSearch
      labelInValue
      loading={isLoading}
      placeholder="เลือกแบรนด์"
      onChange={(value, option) => {
        props?.onChange?.(value, option);
        const selectedBrand = data?.find((ss) => ss.id === value.value);

        if (value.value === 'all') {
          const x = {
            label: 'All',
            value: 'all',
          };
          props?.onChange?.(x, option);
        }

        if (selectedBrand) {
          const x = {
            ...selectedBrand,
            ...omit(value, ['disabled', 'title']),
          };

          props?.onChange?.(x, option);
        }
      }}
    >
      {data?.map((ss, index) => (
        <Option key={index} value={ss.id}>
          {ss.label_en}
        </Option>
      ))}

      {props?.all && <Option value="all">All</Option>}
    </Select>
  );
}

export function useSpSelectItemBrand(props) {
  const { get } = useHttpClient();

  const disabled = !!props?.params?.disabled;

  const queryRequest = useQuery({
    queryKey: masterDataKeys.selectBrand(props?.params).queryKey,
    enabled: !disabled,
    queryFn: async () =>
      await get({
        url: `${appApiMasterIndices}/lost_and_found/brand`,
        params: props?.params || undefined,
      }),
    select: (res) => {
      const { response } = res;
      return response?.data || undefined;
    },
  });

  const lookup = (keywords = '') => {
    try {
      const finds = queryRequest.data.find((ss) => ss.label_en === keywords);
      return finds;
    } catch (error) {
      return null;
    }
  };

  return {
    ...queryRequest,
    lookup,
  };
}
